import React from 'react';
import { applyTypography } from '@repo/common';
import BagItem from './BagItem';

const BagItemGroup = ({
  group = {
    date: 'Fri ∙ 5 Dec 2025',
    items: [],
  },
  onItemToggle,
}) => {
  return (
    <div className='content-stretch flex flex-col gap-[12px] tabletH:gap-[16px] items-start pb-[20px] tabletH:pb-[30px] relative shrink-0 w-full'>
      <p
        className={`typo-b16Strong abletH:typo-b18Strong text-text-primary shrink-0`}
      >
        {group.date}
      </p>
      {group.items.map((item) => (
        <BagItem key={item.id} item={item} onToggle={onItemToggle} />
      ))}
    </div>
  );
};

export default BagItemGroup;
